// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3996":"b6c051b4","4374":"4de4c377","4797":"4de4c377","5188":"4de4c377","6844":"e9629251","8197":"4de4c377","8213":"4de4c377"}[chunkId] + ".chunk.css";
};